<mat-spinner color="primary" class="mx-auto loader"></mat-spinner>